// import { genHtmlOptions, genMenuItems } from "@mui";
import { genMenuItems, genHtmlOptions } from "../utils";

export const REGION_CARD_ARRANGEMENT_TYPES = {};
export const CARD_ARRANGEMENT_HORIZONTAL = "horizontal";
export const CARD_ARRANGEMENT_VERTICAL = "vertical";
REGION_CARD_ARRANGEMENT_TYPES[CARD_ARRANGEMENT_HORIZONTAL] = "Horizontal";
REGION_CARD_ARRANGEMENT_TYPES[CARD_ARRANGEMENT_VERTICAL] = "Vertical";

export const DISPLAY_CURRENCIES = {};
export const DISPLAY_CURRENCY_DEFAULT = 1;
export const DISPLAY_CURRENCY_USD = 2;
export const DISPLAY_CURRENCY_LOCAL = 3;
export const DISPLAY_CURRENCY_DEVICE = 4;
DISPLAY_CURRENCIES[DISPLAY_CURRENCY_DEFAULT] = "Default";
DISPLAY_CURRENCIES[DISPLAY_CURRENCY_USD] = "USD";
DISPLAY_CURRENCIES[DISPLAY_CURRENCY_LOCAL] = "Itinerary local currency";
DISPLAY_CURRENCIES[DISPLAY_CURRENCY_DEVICE] = "User device's locale";

export const SUPPORT_CONTACT_TYPES = {};
export const SUPPORT_CONTACT_PHONE = 1;
export const SUPPORT_CONTACT_EMAIL = 2;
export const SUPPORT_CONTACT_CHAT = 3;
export const SUPPORT_CONTACT_SOCIAL = 4;
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_PHONE] = "Phone";
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_EMAIL] = "Email";
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_CHAT] = "Chat";
SUPPORT_CONTACT_TYPES[SUPPORT_CONTACT_SOCIAL] = "Social";

/** The support contacts the app's "contact support" button can use: social links are not support contacts (the
 *  apps do not get them at all), so they never satisfy a check that a support contact exists or is enabled. */
export const appSupportContacts = (contacts) =>
    (contacts ?? []).filter((c) => +c.contact_type !== SUPPORT_CONTACT_SOCIAL);

export const CTA_BEHAVIORS = {};
export const CTA_BEHAVIOR_LINK_INAPP = 0;
export const CTA_BEHAVIOR_LINK_SYSTEM = 1;
export const CTA_BEHAVIOR_PHONE_NUMBER = 2;
export const CTA_BEHAVIOR_CHAT = 3;
export const CTA_BEHAVIOR_ADD_TRIP = 4;
export const CTA_BEHAVIOR_EXPLORE = 5;
export const CTA_BEHAVIOR_EXPLORE_OR_ADD_TRIP = 6;
CTA_BEHAVIORS[CTA_BEHAVIOR_LINK_INAPP] = "Link via In-App Browser";
CTA_BEHAVIORS[CTA_BEHAVIOR_LINK_SYSTEM] = "Link via System Browser";
CTA_BEHAVIORS[CTA_BEHAVIOR_PHONE_NUMBER] = "Call Support Phone Number";
// CTA_BEHAVIORS[CTA_BEHAVIOR_CHAT] = "Open Assistant Chat";
CTA_BEHAVIORS[CTA_BEHAVIOR_ADD_TRIP] = "Add to My Trips";
CTA_BEHAVIORS[CTA_BEHAVIOR_EXPLORE] = "Show on Explore";
CTA_BEHAVIORS[CTA_BEHAVIOR_EXPLORE_OR_ADD_TRIP] = "Show on Explore or Add to My Trips";

export const CTA_TRIP_DEPARTURES = {};
export const CTA_TRIP_DEPARTURE_NEXT_AVAILABLE = 0;
export const CTA_TRIP_DEPARTURE_MOST_RECENT = 1;
export const CTA_TRIP_DEPARTURE_ASK = 2;
CTA_TRIP_DEPARTURES[CTA_TRIP_DEPARTURE_NEXT_AVAILABLE] = "Next available";
CTA_TRIP_DEPARTURES[CTA_TRIP_DEPARTURE_MOST_RECENT] = "Most recent";
CTA_TRIP_DEPARTURES[CTA_TRIP_DEPARTURE_ASK] = "Ask for date & departure";

export const MONTH = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
};


export const cardArrangementTypesMenuItems = genMenuItems(REGION_CARD_ARRANGEMENT_TYPES);
export const displayCurrenciesMenuItems = genMenuItems(DISPLAY_CURRENCIES);

export const supportContactTypesMenuItems = genMenuItems(SUPPORT_CONTACT_TYPES);
export const supportContactTypesOptions = genHtmlOptions(SUPPORT_CONTACT_TYPES);

export const ctaBehaviorsMenuItems = genMenuItems(CTA_BEHAVIORS);
export const ctaBehaviorsOptions = genHtmlOptions(CTA_BEHAVIORS);

export const ctaTripDeparturesMenuItems = genMenuItems(CTA_TRIP_DEPARTURES);
export const ctaTripDeparturesOptions = genHtmlOptions(CTA_TRIP_DEPARTURES);

export const getDayNumber = (it) => (
    (it.length !== void(0)) ?
        it.length
        :
        (it.days || []).reduce( (a, v) => (+a + +v.day_span), 0)
);
export const formatDayNumber = (n) => (`${n} day${n === 1 ? "" : "s"}`);

export const ConfirmationDialogText = {
    "save_itinerary": { title: "Save changes before leaving?", body: "You have unsaved changes", okButtonText: "Save", cancelButtonText: "Cancel" },
    "delete_itinerary": {title: "Please confirm", body: "Do you really want to delete this itinerary?", okButtonText: "Delete", cancelButtonText: "Cancel"  },
    "delete_itineraries": {title: "Please confirm", body: "Do you really want to delete these itineraries?", okButtonText: "Delete", cancelButtonText: "Cancel"  },
    "delete_filter": {title: "Please confirm", body: "Do you really want to delete this filter?", okButtonText: "Delete", cancelButtonText: "Cancel"  },
    "delete_filters": {title: "Please confirm", body: "Do you really want to delete these filters?", okButtonText: "Delete", cancelButtonText: "Cancel"  },
    "delete_region": {title: "Please confirm", body: "Do you really want to delete this region?", okButtonText: "Delete", cancelButtonText: "Cancel"  },
    "delete_regions": {title: "Please confirm", body: "Do you really want to delete these regions?", okButtonText: "Delete", cancelButtonText: "Cancel"  },
    "unpublish_itinerary": {title: "Please confirm", body: "Do you really want to unpublish this itinerary?", okButtonText: "Unpublish", cancelButtonText: "Cancel"  },
    "unpublish_itineraries": {title: "Please confirm", body: "Do you really want to unpublish these itineraries?", okButtonText: "Unpublish", cancelButtonText: "Cancel"  },
    "publish_itinerary": {title: "Please confirm", body: "Do you really want to publish this itinerary?", okButtonText: "Publish", cancelButtonText: "Cancel"  },
    "publish_itineraries": {title: "Please confirm", body: "Do you really want to publish these itineraries?", okButtonText: "Publish", cancelButtonText: "Cancel"  },
    "change_display_settings_itineraries": {title: "Please confirm", body: "Do you really want to change display settings for these itineraries?", okButtonText: "Change", cancelButtonText: "Cancel"  },
}
